import { ChangeEvent, useState } from "react";
import { isEmailValid } from "../../utils/emailValidation";
import "./index.css";

interface IProps {
  onclkbtn: (n: string) => void;
}

export function EmailScreen(props: IProps) {
  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<string>("");

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
    setError("");
  }

  const onclkbtn = () => {
    if (isEmailValid(value)) {
      props.onclkbtn(value);
    } else {
      setError("Пожалуйста, введите ваш e-mail.");
    }
  };

  return (
    <>
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h2>Ваша E-mail адрес</h2>

          <p>
            Электронная почта необходима для важной информации и восстановления
            доступа
          </p>

          <input
            type="email"
            value={value}
            onChange={handleChange}
            placeholder="E-mail"
            required
            autoFocus
            onKeyUp={(e) => {
              if (e.code === "Enter") {
                onclkbtn();
              }
            }}
          />
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
      <div className="registration-button" onClick={onclkbtn}>
        Далее
      </div>
    </>
  );
}


